import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { UntypedFormArray, UntypedFormControl, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import * as _ from 'lodash';
import { SapFilterComponent } from '../sap-filter/sap-filter.component';

interface IFilterOption {
  id: string;
  navOptionLabel: string;
  filterOptions: {
    id: string
    label: string
  }[],
  type?: 'multi-select' | 'single-select'
  selectAllOption?: { id: string, label: string }
}
@Component({
  selector: 'kt-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit, OnChanges {
  @Input() filterOptions!: IFilterOption[];  // mockobject = [{ id: "1", label: "FilterTitle", filterOptions: [{ id: "a", label: "Option1" }, { id: "b", label: "Option2" }] }]
  @Input() filterTitle!: string ;
  @Input() selectedFilterOptions!: IFilterOption[];
  @Input() loading: boolean = false;
  @Input() isMultiSelect: boolean = true;
  @Input() isDarkBackground: boolean = false
  @Input() containerStyles: any = {};
  @Input() segmentStyles: any = {};
  @Input() optionStyles: any = {}
  @Input() primaryButtonStyles: any = {}
  @Input() filterIconColor: string = ''
  @Output() onFilterApply = new EventEmitter<any>();

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  @ViewChild(SapFilterComponent) form1: SapFilterComponent;

  inputValue = new UntypedFormControl()
  isOpen = false;
  segmentControlOptions: { id: string; label: string; type?: 'single-select' | 'multi-select', selectAllOption?: { id: string, label: string }}[] = []
  segmentSeperatedFilterOptions!: { id: string, label: string }[];
  overlayRef: OverlayRef;
  selectedSegment: { id: string, label: string, type: 'single-select' | 'multi-select', selectAllOption?: { id: string, label: string } } = {
    id: '',
    label: '',
    type:'multi-select',
    selectAllOption:{id:'', label:''}
  };
  searchValue = "";
  selectedOptionsMap: Map<string, { id: string; label: string }[]> = new Map();
  filteredValuesMap:Map<string, { id: string; label: string }[]> = new Map();
  isFilterApplied: boolean = false;
  showSapFieldFilter: boolean = false;
  isApplyFilterEnabled: boolean = false;

  constructor(private readonly overlay: Overlay, private readonly viewContainerRef: ViewContainerRef, private readonly elementRef: ElementRef, private readonly cdr:ChangeDetectorRef) { }

  ngOnInit(): void {
    this.updateSegmentControlOptions()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filterOptions) {
      this.filterOptions = changes.filterOptions.currentValue;
    }
    if(changes.selectedFilterOptions){
      this.selectedFilterOptions = changes.selectedFilterOptions.currentValue
    }
    this.updateSegmentControlOptions();
  }

  updateSegmentControlOptions() {
    this.filterOptions.filter((filterOption) => {
      if (!this.segmentControlOptions.some(opt => opt.id === filterOption.id))
        this.segmentControlOptions.push({ label: filterOption.navOptionLabel, id: filterOption.id, type: filterOption?.type, selectAllOption: filterOption.selectAllOption });
    })
    this.segmentSeperatedFilterOptions = this.filterOptions[0]?.filterOptions;
    if (!this.showSapFieldFilter) {
      this.selectedSegment.id = 'Fields';
      this.selectedSegment.label = 'Fields';
    }
    else {
      this.selectedSegment.id = this.filterOptions[0]?.id;
      this.selectedSegment.label = this.filterOptions[0]?.navOptionLabel;
      this.selectedSegment.type = this.filterOptions[0]?.type;
    }
    if (this.selectedSegment.selectAllOption) {
      this.selectedSegment.selectAllOption.id = this.selectedSegment.selectAllOption?.id || '';
      this.selectedSegment.selectAllOption.label = this.selectedSegment.selectAllOption?.label || '';
    }
    this.searchValue = "";
    this.selectedOptionsMap.clear();
    if (this.selectedFilterOptions?.length) {
      this.selectedFilterOptions.forEach((selectedFilter) => {
        const filterOption = this.filterOptions.find(filter => filter.id === selectedFilter.id);
        const isAllOptionSelected = selectedFilter.filterOptions.find((option) => option.id == filterOption?.selectAllOption?.id)
        if (isAllOptionSelected && filterOption?.type !== 'single-select') {
          const filterOptions = _.cloneDeep(filterOption.filterOptions)
          this.selectedOptionsMap.set(selectedFilter.id, [...filterOptions, filterOption?.selectAllOption]);
        } else {
          this.selectedOptionsMap.set(selectedFilter.id, selectedFilter.filterOptions);
        }
      });
    }
    this.selectedFilterOptions = Array.from(this.selectedOptionsMap.entries()).map(([id, options]) => {
      const filterOption = this.filterOptions.find(filter => filter.id === id);
      return {
        id: id,
        navOptionLabel: filterOption?.navOptionLabel || '',
        filterOptions: options,
        type: filterOption?.type,
        selectAllOption: filterOption?.selectAllOption
      };
    });
  }

  handleOpenFilter() {
    this.isOpen = true;
    if (!this.isFilterApplied) {
      this.selectedOptionsMap.clear();
    }
    if (this.isFilterApplied && this.selectedFilterOptions?.length !== this.selectedOptionsMap.size) {
      this.selectedFilterOptions?.map((selectedFilter) => {
        this.selectedOptionsMap.set(selectedFilter.id, selectedFilter.filterOptions);
      })
    }
    this.updateSegmentControlOptions();

  }

  onFilterChange(): void {
    let selectedFilterValues = [];
    if (this.selectedSegment.id != 'Fields') {
      const copiedMap = new Map(this.selectedOptionsMap);
      copiedMap.forEach((value, key) => {
        const filterObject = { id: key, navOptionLabel: key, filterOptions: [...value] };
        selectedFilterValues.push(filterObject);
      });
    }
    else {
      if (this.form1 && this.form1.dynamicForm) {
        const formArray = this.form1.dynamicForm.get('filters') as UntypedFormArray;
        if (formArray && formArray.controls) {
          let data = formArray.value || [];

          if (Array.isArray(data)) {
            data.forEach((group) => {
              let singleFilter = { name: "sapFilter", id: "", operator: "", value: "" };

              if (group.selectedField) {
                singleFilter.id = group.selectedField;
              }
              if (group.selectedCheck) {
                singleFilter.operator = group.selectedCheck;
              }
              if (group?.dropDownInputValue) {
                singleFilter.value = group?.dropDownInputValue;
              } else if (group?.dateInputvalue) {
                singleFilter.value = group?.dateInputvalue;
              } else if (group?.inputValue) {
                singleFilter.value = group?.inputValue;
              }
              selectedFilterValues.push(singleFilter);
            });
          }
        }
      }
    }
    this.onFilterApply.emit([...selectedFilterValues])
    this.isFilterApplied = true;
    this.menuTrigger?.closeMenu();
    this.isOpen = false;
  }

  onSegmentChange(segment) {
    this.searchValue = ""
    this.selectedSegment.id = segment?.id;
    this.selectedSegment.label = segment?.label
    this.selectedSegment.type = segment?.type
    this.selectedSegment.selectAllOption = segment.selectAllOption ? { ...segment.selectAllOption } : undefined; this.segmentSeperatedFilterOptions = this.filterOptions.find(filter => filter.id === segment.id)?.filterOptions;
    if (segment?.id === 'Fields') {
      this.showSapFieldFilter = false;
      this.selectedSegment.id = segment?.id;
      this.selectedSegment.label = segment?.label
    }
    else this.showSapFieldFilter = false;
  }

  onCancel() {
    this.showSapFieldFilter = false;
    this.menuTrigger.updatePosition();
    this.menuTrigger.closeMenu();
    this.updateSegmentControlOptions()
  }

  search(event) {
    const currentFilterOptions = this.filterOptions.find(filter => filter.id === this.selectedSegment.id)?.filterOptions;
    if (event?.target.value)
      this.segmentSeperatedFilterOptions = currentFilterOptions.filter((option) => option.label.toLowerCase().includes(event?.target.value.toLowerCase()));
    else {
      this.filterOptions.map((filterOption) => {
        if (filterOption.id == this.selectedSegment.id) {
          this.segmentSeperatedFilterOptions = filterOption.filterOptions;
        }
      })
    }
  }

  isOptionSelected(option) {
    const selectedOptions = Array.from(this.selectedOptionsMap.values()).reduce((acc, curr) => {
      return [...acc, ...curr];
    }, []);

    if (this.selectedSegment.type === 'single-select') {
      const selectedOption = this.selectedOptionsMap.get(this.selectedSegment.id);
      if (selectedOption && selectedOption.length > 0) {
        return selectedOption[0].id === option.value.id;
      }
      return false;
    }

    if (this.selectedSegment.selectAllOption) {
      const isSelectAllSelected = selectedOptions.some(selected => selected.id === this.selectedSegment?.selectAllOption?.id);
      if (isSelectAllSelected) {
        return true;
      }
    }
    return selectedOptions.some((selectedOption) => selectedOption?.id == option?.value.id);
  }

  onSelectAllOption() {
    const currentFilterOption = this.filterOptions.find(filter => filter.id === this.selectedSegment.id);
    const filterOptions = currentFilterOption?.filterOptions || [];
    const selectedFilterOptions = this.selectedOptionsMap.get(this.selectedSegment.id) || [];
    let isAllOptionSelected = selectedFilterOptions.find((selectedFilter) => selectedFilter.id == currentFilterOption?.selectAllOption?.id);
    if (isAllOptionSelected) {
      this.selectedOptionsMap.set(this.selectedSegment.id, []);
    } else {
      this.selectedOptionsMap.set(this.selectedSegment.id, [...filterOptions, currentFilterOption?.selectAllOption]);
    }
  }

  areAllOptionsSelected(): boolean {
    const selectedOptions = this.selectedOptionsMap.get(this.selectedSegment.id) || [];
    if (this.selectedSegment?.selectAllOption) {
      return selectedOptions.some(selected => selected?.id === this.selectedSegment?.selectAllOption?.id);
    }
    const currentFilterOptions = this.filterOptions.find(filter => filter.id === this.selectedSegment.id)?.filterOptions || [];
    return (currentFilterOptions.length > 0 && selectedOptions.length === currentFilterOptions.length);
  }


onFilterOptionSelect(option: any) {
  const selectedOption = option.value;
  const existingSelectedOptions = this.selectedOptionsMap.get(this.selectedSegment.id) || [];
  if (this.selectedSegment.type === 'single-select') {
    if (existingSelectedOptions.length === 0 || existingSelectedOptions[0].id !== selectedOption.id) {
      this.selectedOptionsMap.set(this.selectedSegment.id, [selectedOption]);
    } else {
      this.selectedOptionsMap.set(this.selectedSegment.id, []);
    }
  } else {
    const isOptionSelected = existingSelectedOptions.some(opt => opt.id === selectedOption.id);
    let updatedOptions;
    if (isOptionSelected) {
      updatedOptions = existingSelectedOptions.filter(opt => opt.id !== selectedOption.id);
      this.selectedOptionsMap.set(this.selectedSegment.id, updatedOptions);
    } else {
      updatedOptions = [...existingSelectedOptions, selectedOption];
      this.selectedOptionsMap.set(this.selectedSegment.id, updatedOptions);
    }
    if (this.selectedSegment?.selectAllOption) {
      const allOptions = this.filterOptions.find(filter => filter.id === this.selectedSegment.id)?.filterOptions || [];
      const allOptionsSelected = allOptions.every(opt => updatedOptions?.some(sel => sel.id === opt.id));
      if (allOptionsSelected) {
        this.selectedOptionsMap.set(this.selectedSegment.id, [...updatedOptions, this.selectedSegment?.selectAllOption]);
      } else {
        const selectAllOptionIndex = updatedOptions?.findIndex(opt => opt.id === this.selectedSegment?.selectAllOption.id);
        if (selectAllOptionIndex !== -1) {
          const updatedOptionsWithoutSelectAll = updatedOptions?.filter(opt => opt.id !== this.selectedSegment?.selectAllOption.id);
          if (updatedOptionsWithoutSelectAll) {
            this.selectedOptionsMap.set(this.selectedSegment.id, updatedOptionsWithoutSelectAll);
          }
        }
      }
    }
  }
}

  isResetApplyButtonDisabled() {
    if (this.selectedSegment.id == 'Fields') {
      if (this.form1) {
        return !this.form1.dynamicForm.valid;
      }
    }
    const selectedOptions = Array.from(this.selectedOptionsMap.values()).reduce((acc, curr) => {
      return [...acc, ...curr];
    }, []);
    let selectedFilterOptions = [];
    if (this.selectedFilterOptions.length) {
      this.selectedFilterOptions?.map((selectedFilterOption) => {
        if (selectedFilterOption?.filterOptions?.length) {
          if (selectedFilterOption?.filterOptions?.length) {
            selectedFilterOption?.filterOptions?.map((filterOption) => {
              selectedFilterOptions.push(filterOption);
            })
          }
        }
      });
    }
    if (selectedOptions.length === selectedFilterOptions.length) {
      return selectedOptions.every(obj1 =>
        selectedFilterOptions.some(obj2 => obj1.id === obj2.id)
      );
    }
    if (this.selectedOptionsMap.size === 0 && selectedFilterOptions.length) {
      return false;
    }
    if (this.selectedOptionsMap.size === 0 && selectedOptions.length === 0) {
      return true;
    }
    if (selectedOptions.length === 0 && selectedFilterOptions.length === 0) {
      return true;
    }
    if (selectedOptions.length >= 0 && selectedFilterOptions.length === 0) {
      return false;
    }
    if (selectedFilterOptions.length === 0) {
      return true;
    }
    return false;
  }

  onFilterValidityChange(isValid: boolean) {
    this.isApplyFilterEnabled = isValid;
  }
}
